<template>
  <div>
    <customerBasicInfo
      :source="customerData"
      :list="personalBasicInfoList"
    />
    <payInfo
      :source="customerData"
      :list="personalPayList"
    />
    <EmergencyContact :data="customerData.emergencyContactList" />

    <CarServicer :data="customerData" />

    <recommender
      :source="customerData"
      :list="recommenderList"
    />
  </div>
</template>
<script>
import CarServicer from '../../components/CarServicer.vue'
import customerBasicInfo from '../../components/customerBasicInfo.vue'
import payInfo from '../../components/payInfo.vue'
import recommender from '../../components/recommender'
import commonConfigFn from '../../config'
import configFn from './config'
import EmergencyContact from '../../components/EmergencyContact.vue'

export default {
  name: 'basicInfo',
  components: {
    customerBasicInfo,
    payInfo,
    recommender,
    EmergencyContact,
    CarServicer,
  },
  props: ['customerData'],
  data() {
    const { personalBasicInfoList, personalPayList } = configFn.call(this)
    const { recommenderList } = commonConfigFn.call(this)
    return {
      // 个人 客户基本信息
      personalBasicInfoList,
      // 个人 支付信息
      personalPayList,
      // 推荐人信息
      recommenderList,
    }
  },
}
</script>
